import { Sprite, themes } from "@may-i/mash-design-system";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "styled-components";
import { ToastProvider } from "~/shared/ui/toast";

const queryClient = new QueryClient();

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider theme={themes.light}>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          {children}
        </ToastProvider>
      </QueryClientProvider>
      <Sprite width={0} height={0} display="block" />
    </ThemeProvider>
  );
}
